import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Checkbox } from '@ferris/react/components/forms';
import { TrackingContext } from '@vrbo/react-event-tracking';
import LeadActions from '../../../actions/lead';
import TranslationUtil from '../../../utils/TranslationUtil';
import {
    optStatus, getMarketingEmailOptStatus, getOptOutState, hasOptOutAnyTime
} from '../../../utils/NewsLetterUtil';
import { capitalizeBrand } from '../../../utils/BrandUtil';

export function NewsLetter({
    optInText,
    optOutText,
    optOutAnyTimeText,
    emailOptOut,
    setMarketingEmailSubscription,
    siteName
}) {
    const status = getMarketingEmailOptStatus(siteName);
    const { trigger } = useContext(TrackingContext);
    const sendEvent = (isOptedOut) => trigger('genericClick', {
        category: 'answer',
        action: 'opt-out-marketing-email',
        isOptedOut
    });
    const handleCheckChange = (e) => {
        const isChecked = e.target.checked;
        if (status === optStatus.OPT_IN_CHECKBOX) {
            sendEvent(!isChecked);
            setMarketingEmailSubscription(!isChecked);
        } else if (status === optStatus.OPT_OUT_CHECKBOX) {
            sendEvent(isChecked);
            setMarketingEmailSubscription(isChecked);
        }
    };

    let newsLetterText = status === optStatus.OPT_IN_CHECKBOX ? optInText : optOutText;
    const isEmailOptChecked = status === optStatus.OPT_IN_CHECKBOX ? !emailOptOut : emailOptOut;

    if (status === optStatus.OPT_IN_DEFAULT) {
        return '';
    }

    if (status === optStatus.OPT_OUT_CHECKBOX) {
        const hasOptOutAnyTimeText = hasOptOutAnyTime(siteName);
        if (hasOptOutAnyTimeText) {
            newsLetterText += optOutAnyTimeText;
        }
    }
    return (
        <Checkbox
            data-wdio="newsletter-checkbox"
            checked={isEmailOptChecked}
            label={newsLetterText}
            name="newsLetter"
            onChange={handleCheckChange}
        />
    );
}

NewsLetter.propTypes = {
    optInText: PropTypes.string.isRequired,
    optOutText: PropTypes.string.isRequired,
    optOutAnyTimeText: PropTypes.string,
    setMarketingEmailSubscription: PropTypes.func.isRequired,
    emailOptOut: PropTypes.bool.isRequired,
    siteName: PropTypes.string
};

// default to showing a opt out checkbox when there isn't a site name
NewsLetter.defaultProps = {
    siteName: 'homeaway_uk',
    optOutAnyTimeText: ''
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    setMarketingEmailSubscription: (isOptedOut) => dispatch(LeadActions
        .setMarketingEmailSubscription(isOptedOut))
});

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app, lead } = state;
    const { emailOptOut, explicitlyChosen } = lead;
    const { brand, siteName } = app;
    const brandName = capitalizeBrand(brand);
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const getTranslation = (suffix, params) => translations.getTranslation(`Vrbo.lyp.leadForm.newsletter.${suffix}`, params);

    return {
        optInText: getTranslation('optIn', { brandName }),
        optOutText: getTranslation('optOut', { brandName }),
        optOutAnyTimeText: getTranslation('optOutAnyTime'),
        emailOptOut: getOptOutState(siteName, emailOptOut, explicitlyChosen),
        siteName
    };
};

const ConnectedNewsLetter = connect(
    mapStateToProps,
    mapDispatchToProps
)(NewsLetter);
ConnectedNewsLetter.displayName = 'NewsLetter';
export default ConnectedNewsLetter;
